import Validation from "@/classes/global/Validation";

export default class QuoteValidation {

    constructor() {

        this.quoteType = new Validation();
        this.origin = new Validation();
        this.destination = new Validation();
        this.originPort = new Validation();
        this.destinationPort = new Validation();
        this.valueCurrency = new Validation();
        this.value = new Validation();
        this.movementDate = new Validation();
        this.deliveryDate = new Validation();
        this.transportMode = new Validation();
        this.hazardClass = new Validation();
        this.commodity = new Validation();
        this.customerRef = new Validation();
    }
}